(function () {
  var restrictedTag = (window.__restrictedProductTag || '').toLowerCase();
  if (!restrictedTag) return;
  var debounceTimer = null;
  var productCache = Object.create(null);

  var MAX_RETRIES = 3;

  function hideCardControls(card) {
    ['.st-atc-button', '.st-wishlist-button', '.st-product-card_price'].forEach(function (selector) {
      var el = card.querySelector(selector);
      if (el && el.style.display !== 'none') el.style.display = 'none';
    });
  }

  function processCard(card, handle) {
    card.setAttribute('data-restricted-checked', 'pending');

    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(function (product) {
          return (product.tags || []).map(function (t) { return t.toLowerCase(); });
        })
        .catch(function () {
          delete productCache[handle];
          return null;
        });
    }

    productCache[handle].then(function (tags) {
      if (!tags) {
        // Failed check: stay retryable, up to MAX_RETRIES.
        var retries = Number(card.getAttribute('data-restricted-retries') || 0) + 1;
        card.setAttribute('data-restricted-retries', retries);
        if (retries < MAX_RETRIES) {
          card.setAttribute('data-restricted-checked', 'retrying');
          setTimeout(function () {
            card.removeAttribute('data-restricted-checked');
            hideRestrictedButtons();
          }, retries * 1000);
        } else {
          card.setAttribute('data-restricted-checked', 'failed');
        }
        return;
      }

      if (tags.indexOf(restrictedTag) !== -1) {
        card.setAttribute('data-restricted-checked', 'restricted');
        hideCardControls(card);
      } else {
        card.setAttribute('data-restricted-checked', 'allowed');
      }
    });
  }

  function hideRestrictedButtons() {
    // Swishlist wishlist page cards. Restricted cards are re-hidden on every pass
    // because Swishlist can inject or replace controls after the check resolved.
    document.querySelectorAll('st-product-card').forEach(function (card) {
      var state = card.getAttribute('data-restricted-checked');
      if (state === 'restricted') {
        hideCardControls(card);
      } else if (!state) {
        var handle = card.getAttribute('data-handle');
        if (handle) {
          processCard(card, handle);
        } else {
          card.setAttribute('data-restricted-checked', 'allowed');
        }
      }
    });

    // Standard product-card — Liquid already computed restriction via data-restricted attr.
    // Do NOT mark as checked permanently: Swishlist injects .st-wishlist-button after render,
    // so we must re-hide on every call until the button is found and hidden.
    document.querySelectorAll('product-card[data-restricted="true"]').forEach(function (card) {
      var wishlistBtn = card.querySelector('.st-wishlist-button:not([data-restricted-hidden])');
      if (wishlistBtn) {
        wishlistBtn.style.display = 'none';
        wishlistBtn.setAttribute('data-restricted-hidden', 'true');
      }
    });
  }

  function debouncedHide() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(hideRestrictedButtons, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideRestrictedButtons);
  } else {
    hideRestrictedButtons();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        debouncedHide();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
